import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportViewComponent } from '../report-view/report-view.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { FormGroup, FormBuilder, Validators, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [ReportViewComponent],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    FormsModule,
    AngularMultiSelectModule
  ],
  exports: [
    ReportViewComponent
  ],
  entryComponents: [
    //ReportViewComponent,
  ]
})
export class ReportViewModuleModule { }
